import { render, staticRenderFns } from "./SaleStatusLabel.vue?vue&type=template&id=7507a7f3"
import script from "./SaleStatusLabel.vue?vue&type=script&lang=js"
export * from "./SaleStatusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports